/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Step_3Inputs */

const en_claims_step_3 = /** @type {(inputs: Claims_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save the completed claim form on your device.`)
};

const fr_claims_step_3 = /** @type {(inputs: Claims_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrez le formulaire de réclamation rempli sur votre appareil.`)
};

/**
* | output |
* | --- |
* | "Save the completed claim form on your device." |
*
* @param {Claims_Step_3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_step_3 = /** @type {((inputs?: Claims_Step_3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Step_3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_step_3(inputs)
	return fr_claims_step_3(inputs)
});